export default __webpack_public_path__ + "static/2079-cbd9ecb746cebea0e161050d1c6a1a36.jpeg";